import { AMLFormPublic } from '@/components/aml-forms';

export function AMLFormPublicPage() {
  return <AMLFormPublic />;
}
